<template>
  <!-- L'onglet Absences du membre : les recharges à domicile de ces jours-là ne sont pas remboursées -->
  <div v-if="member && member.id" class="member-absences">
    <headline class="mt-10">{{ $t('member.absences.title') }}</headline>
    <member-absences :member="member" embedded />
  </div>
</template>

<script>
import MemberAbsences from './MemberAbsences.vue'

export default {
  components: { MemberAbsences },

  computed: {
    member() {
      return this.$parent.member ?? null
    },
  },
}
</script>
